import styled from 'styled-components'

import { helpers } from 'styles'

export const Header = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: minmax(150px, 1fr) minmax(130px, 250px);
	column-gap: 8px;
	justify-content: space-between;
	align-items: center;
	background-color: ${helpers.color.codeBlockBackgroundHeader};
	color: ${helpers.color.textContrast};
	font-family: ${helpers.font.family.header};
	padding: 10px 12px;
	border-radius: 8px 8px 0 0;
`
